export type SystemNotification = { id: number; title: string; description: string; count: number };
export function createNotificationStore() {
  let items: SystemNotification[] = [];
  let sequence = 0;
  const listeners = new Set<() => void>();
  const emit = () => listeners.forEach(listener => listener());
  return {
    subscribe(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; },
    getSnapshot: () => items,
    push(input: { title: string; description: string }) {
      const duplicate = items.find(item => item.title === input.title && item.description === input.description);
      if (duplicate) items = items.map(item => item.id === duplicate.id ? { ...item, count: item.count + 1 } : item);
      else if (items.length < 4) items = [...items, { ...input, id: ++sequence, count: 1 }];
      else {
        const summary = items.find(item => item.id === -1);
        items = summary ? items.map(item => item.id === -1 ? { ...item, count: item.count + 1 } : item)
          : [...items, { id: -1, title: 'More uploads failed', description: 'Some additional files could not be uploaded. Check their format and size, then retry them individually.', count: 1 }];
      }
      emit();
    },
    dismiss(id: number) { items = items.filter(item => item.id !== id); emit(); },
    clear() { items = []; emit(); },
  };
}
export const systemNotifications = createNotificationStore();
export const notifyUploadFailure = (notice: { title: string; description: string }) => systemNotifications.push(notice);
